import { FC } from 'react';
import { FormGroup as MuiFormGroup, FormGroupProps } from '@mui/material';

export const FormGroup: FC<FormGroupProps> = ({ children, ...props }) => {
  return <MuiFormGroup {...props}>{children}</MuiFormGroup>;
};
